var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content_area", attrs: { id: "top_content" } },
    [
      _c("section", [
        _vm._m(0),
        _vm._v(" "),
        _c("article", { staticClass: "category_list" }, [
          _c("div", [
            _c(
              "div",
              {
                staticClass: "category",
                on: {
                  click: function($event) {
                    _vm.routeCategory("DcCategory", { cid: 1 })
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "category_img",
                  attrs: { src: _vm.getImage("top/category/category_ww.jpg") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "category_text" }, [_vm._v("吊戸棚")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "category",
                on: {
                  click: function($event) {
                    _vm.routeCategory("DcCategory", { cid: 2 })
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "category_img",
                  attrs: { src: _vm.getImage("top/category/category_cb.jpg") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "category_text" }, [_vm._v("食器棚")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "category",
                on: {
                  click: function($event) {
                    _vm.routeCategory("DcCategory", { cid: 3 })
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "category_img",
                  attrs: { src: _vm.getImage("top/category/category_sc.jpg") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "category_text" }, [
                  _vm._v("玄関収納")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "category",
                on: {
                  click: function($event) {
                    _vm.routeCategory("DcCategory", { cid: 5 })
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "category_img",
                  attrs: { src: _vm.getImage("top/category/category_sh.jpg") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "category_text" }, [_vm._v("棚板")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "category",
                on: {
                  click: function($event) {
                    _vm.routeCategory("DcCategory", { cid: 6 })
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "category_img",
                  attrs: { src: _vm.getImage("top/category/category_uc.jpg") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "category_text" }, [
                  _vm._v("カウンター下収納")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "category",
                on: {
                  click: function($event) {
                    _vm.routeCategory("DcCategory", { cid: 7 })
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "category_img",
                  attrs: { src: _vm.getImage("top/category/category_sb.jpg") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "category_text" }, [
                  _vm._v("サイドボード")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "category",
                on: {
                  click: function($event) {
                    _vm.routeCategory("DcCategory", { cid: 8 })
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "category_img",
                  attrs: { src: _vm.getImage("top/category/category_tv.jpg") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "category_text" }, [
                  _vm._v("テレビボード")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "category",
                on: {
                  click: function($event) {
                    _vm.routeCategory("DcCategory", { cid: 9 })
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "category_img",
                  attrs: { src: _vm.getImage("top/category/category_bs.jpg") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "category_text" }, [_vm._v("本棚")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "category",
                on: {
                  click: function($event) {
                    _vm.routeCategory("DcCategory", { cid: 14 })
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "category_img",
                  attrs: { src: _vm.getImage("top/category/category_cl.jpg") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "category_text" }, [
                  _vm._v("クローゼット収納")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "category",
                on: {
                  click: function($event) {
                    _vm.routeCategory("DcCategory", { cid: 15 })
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "category_img",
                  attrs: { src: _vm.getImage("top/category/category_ns.jpg") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "category_text" }, [
                  _vm._v("隙間収納")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "category",
                on: {
                  click: function($event) {
                    _vm.routeCategory("DcCategory", { cid: 18 })
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "category_img",
                  attrs: { src: _vm.getImage("top/category/category_sf.webp") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "category_text" }, [
                  _vm._v("シェルフ")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(1)
        ])
      ]),
      _vm._v(" "),
      _c("section", [
        _vm._m(2),
        _vm._v(" "),
        _c("article", { staticClass: "location_list" }, [
          _c("div", [
            _c("div", { staticClass: "location" }, [
              _c("div", { staticClass: "location_img" }, [
                _c("img", {
                  attrs: { src: _vm.getImage("top/content/scene-living.png") }
                }),
                _vm._v(" "),
                _vm._m(3)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "location_item location_sub" }, [
                _c("div", [
                  _c("ul", { staticClass: "location_cat" }, [
                    _c(
                      "li",
                      {
                        staticClass: "cat_item",
                        on: {
                          click: function($event) {
                            _vm.routeCategory("DcCategory", { cid: 1 })
                          }
                        }
                      },
                      [_c("a", [_vm._v("吊戸棚")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "cat_item",
                        on: {
                          click: function($event) {
                            _vm.routeCategory("DcCategory", { cid: 8 })
                          }
                        }
                      },
                      [_c("a", [_vm._v("テレビボード")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "cat_item",
                        on: {
                          click: function($event) {
                            _vm.routeCategory("DcCategory", { cid: 5 })
                          }
                        }
                      },
                      [_c("a", [_vm._v("棚板")])]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("ul", { staticClass: "location_cat_sub" }, [
                    _c(
                      "li",
                      {
                        staticClass: "cat_item cat_sub",
                        on: {
                          click: function($event) {
                            _vm.routeCategory("DcCategory", { cid: 7 })
                          }
                        }
                      },
                      [_c("a", [_vm._v("サイドボード")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "cat_item cat_sub",
                        on: {
                          click: function($event) {
                            _vm.routeCategory("DcCategory", { cid: 18 })
                          }
                        }
                      },
                      [_c("a", [_vm._v("シェルフ")])]
                    )
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "location" }, [
              _c("div", { staticClass: "location_img" }, [
                _c("img", {
                  attrs: { src: _vm.getImage("top/content/scene-dining.png") }
                }),
                _vm._v(" "),
                _vm._m(4)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "location_item" }, [
                _c("ul", { staticClass: "location_cat" }, [
                  _c(
                    "li",
                    {
                      staticClass: "cat_item",
                      on: {
                        click: function($event) {
                          _vm.routeCategory("DcCategory", { cid: 6 })
                        }
                      }
                    },
                    [_c("a", [_vm._v("カウンター下収納")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "cat_item",
                      on: {
                        click: function($event) {
                          _vm.routeCategory("DcCategory", { cid: 7 })
                        }
                      }
                    },
                    [_c("a", [_vm._v("サイドボード")])]
                  ),
                  _vm._v(" "),
                  _vm._m(5),
                  _vm._v(" "),
                  _vm._m(6),
                  _vm._v(" "),
                  _vm._m(7),
                  _vm._v(" "),
                  _vm._m(8),
                  _vm._v(" "),
                  _vm._m(9)
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "location" }, [
              _c("div", { staticClass: "location_img" }, [
                _c("img", {
                  attrs: { src: _vm.getImage("top/content/scene-kitchen.png") }
                }),
                _vm._v(" "),
                _vm._m(10)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "location_item" }, [
                _c("ul", { staticClass: "location_cat" }, [
                  _c(
                    "li",
                    {
                      staticClass: "cat_item",
                      on: {
                        click: function($event) {
                          _vm.routeCategory("DcCategory", { cid: 2 })
                        }
                      }
                    },
                    [_c("a", [_vm._v("食器棚")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "cat_item",
                      on: {
                        click: function($event) {
                          _vm.routeCategory("DcCategory", { cid: 15 })
                        }
                      }
                    },
                    [_c("a", [_vm._v("隙間収納")])]
                  ),
                  _vm._v(" "),
                  _vm._m(11)
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "location" }, [
              _c("div", { staticClass: "location_img" }, [
                _c("img", {
                  attrs: { src: _vm.getImage("top/content/scene-washroom.png") }
                }),
                _vm._v(" "),
                _vm._m(12)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "location_item" }, [
                _c("ul", { staticClass: "location_cat" }, [
                  _c(
                    "li",
                    {
                      staticClass: "cat_item",
                      on: {
                        click: function($event) {
                          _vm.routeCategory("DcCategory", { cid: 1 })
                        }
                      }
                    },
                    [_c("a", [_vm._v("吊戸棚")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "cat_item",
                      on: {
                        click: function($event) {
                          _vm.routeCategory("DcCategory", { cid: 15 })
                        }
                      }
                    },
                    [_c("a", [_vm._v("隙間収納")])]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "location" }, [
              _c("div", { staticClass: "location_img" }, [
                _c("img", {
                  attrs: { src: _vm.getImage("top/content/scene-study.png") }
                }),
                _vm._v(" "),
                _vm._m(13)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "location_item" }, [
                _c("ul", { staticClass: "location_cat" }, [
                  _c(
                    "li",
                    {
                      staticClass: "cat_item",
                      on: {
                        click: function($event) {
                          _vm.routeCategory("DcCategory", { cid: 9 })
                        }
                      }
                    },
                    [_c("a", [_vm._v("本棚")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "cat_item",
                      on: {
                        click: function($event) {
                          _vm.routeCategory("DcCategory", { cid: 14 })
                        }
                      }
                    },
                    [_c("a", [_vm._v("クローゼット収納")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "cat_item",
                      on: {
                        click: function($event) {
                          _vm.routeCategory("DcCategory", { cid: 18 })
                        }
                      }
                    },
                    [_c("a", [_vm._v("シェルフ")])]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "location" }, [
              _c("div", { staticClass: "location_img" }, [
                _c("img", {
                  attrs: { src: _vm.getImage("top/content/scene-entrance.png") }
                }),
                _vm._v(" "),
                _vm._m(14)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "location_item" }, [
                _c("ul", { staticClass: "location_cat" }, [
                  _c(
                    "li",
                    {
                      staticClass: "cat_item",
                      on: {
                        click: function($event) {
                          _vm.routeCategory("DcCategory", { cid: 3 })
                        }
                      }
                    },
                    [_c("a", [_vm._v("玄関収納")])]
                  ),
                  _vm._v(" "),
                  _vm._m(15),
                  _vm._v(" "),
                  _vm._m(16),
                  _vm._v(" "),
                  _vm._m(17)
                ])
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content_head" }, [
      _c("div", { staticClass: "content_title" }, [_vm._v("CATEGORY")]),
      _vm._v(" "),
      _c("div", { staticClass: "content_text" }, [
        _vm._v("カテゴリから商品を選ぶ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dummy" }, [_c("div")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content_head" }, [
      _c("div", { staticClass: "content_title" }, [_vm._v("SCENE")]),
      _vm._v(" "),
      _c("div", { staticClass: "content_text" }, [_vm._v("部屋から商品を選ぶ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "location_name" }, [
      _vm._v("Living Room"),
      _c("br"),
      _vm._v("リビング")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "location_name" }, [
      _vm._v("Dining Room"),
      _c("br"),
      _vm._v("ダイニング")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "cat_item" }, [_c("a", [_c("br")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "cat_item" }, [_c("a", [_c("br")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "cat_item" }, [_c("a", [_c("br")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "cat_item" }, [_c("a", [_c("br")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "cat_item" }, [_c("a", [_c("br")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "location_name" }, [
      _vm._v("Kitchen"),
      _c("br"),
      _vm._v("キッチン")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "cat_item" }, [_c("a", [_c("br")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "location_name" }, [
      _vm._v("Washroom / Bath"),
      _c("br"),
      _vm._v("洗面所・バス")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "location_name" }, [
      _vm._v("Study / Closet"),
      _c("br"),
      _vm._v("書斎・クローゼット")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "location_name" }, [
      _vm._v("Entrance / Entrance"),
      _c("br"),
      _vm._v("玄関・エントランス")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "cat_item" }, [_c("a", [_c("br")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "cat_item" }, [_c("a", [_c("br")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "cat_item" }, [_c("a", [_c("br")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-326b15dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-326b15dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/top/DcTopContent.vue
// module id = null
// module chunks = 